import React, { useState } from "react";
import PropTypes from "prop-types";
import FincludeLogo from "../../../assets/images/finclude.png";
import { Link } from "react-router-dom";
import { Field, Form } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import isEmpty from "lodash/isEmpty";
import ValidatedInput from "../../common/ValidatedInput";
import {
  capitalLetterRegex,
  lowerCaseLetterRegex,
  numbersRegex,
  specialCharRegex,
} from "../helpers";

const SignUpForm = ({ onSubmit }) => {
  const [lengthLink, setLengthLink] = useState("");
  const [specialCharLink, setSpecialCharLink] = useState("");
  const [capitalLetterLink, setCapitalLetterLink] = useState("");
  const [lowerLetterLink, setLowerLetterLink] = useState("");
  const [numberLink, setNumberLink] = useState("");
  const [lengthCheck, setLengthCheck] = useState("");
  const [specialCharCheck, setSpecialCharCheck] = useState("");
  const [capitalLetterCheck, setCapitalLetterCheck] = useState("");
  const [lowerLetterCheck, setLowerLetterCheck] = useState("");
  const [numberCheck, setNumberCheck] = useState("");

  const [passwordType, setPasswordType] = useState("password");
  const [passwordClass, setPasswordClass] = useState("");

  const handlePasswordVisibility = () => {
    if (passwordType === "text") {
      setPasswordType("password");
      setPasswordClass("");
    } else {
      setPasswordType("text");
      setPasswordClass("password-show");
    }
  };

  const validateSpecialChar = (value) => {
    if (specialCharRegex.test(value)) {
      setSpecialCharLink("text-link");
      setSpecialCharCheck("icon-check ml-1");
    } else {
      setSpecialCharLink("");
      setSpecialCharCheck("");
    }
  };

  const validateCapitalLetter = (value) => {
    if (capitalLetterRegex.test(value)) {
      setCapitalLetterLink("text-link");
      setCapitalLetterCheck("icon-check ml-1");
    } else {
      setCapitalLetterLink("");
      setCapitalLetterCheck("");
    }
  };

  const validateNumber = (value) => {
    if (numbersRegex.test(value)) {
      setNumberLink("text-link");
      setNumberCheck("icon-check ml-1");
    } else {
      setNumberLink("");
      setNumberCheck("");
    }
  };
  const validateLowerLetter = (value) => {
    if (lowerCaseLetterRegex.test(value)) {
      setLowerLetterLink("text-link");
      setLowerLetterCheck("icon-check ml-1");
    } else {
      setLowerLetterLink("");
      setLowerLetterCheck("");
    }
  };

  const validateLength = (value) => {
    if (value.length >= 8) {
      setLengthLink("text-link");
      setLengthCheck("icon-check ml-1");
    } else {
      setLengthLink("");
      setLengthCheck("");
    }
  };

  return (
    <Form
      onSubmit={onSubmit}
      render={({
        submitError,
        handleSubmit,
        form,
        submitting,
        pristine,
        values,
      }) => (
        <form className="box mw-400 p-sm-5" onSubmit={handleSubmit}>
          <img
            className="d-block mx-auto mb-4"
            src={FincludeLogo}
            alt="Finclude"
          />
          <h5 className="text-center mb-3">Create account</h5>
          {submitError && (
            <p className="text-center text-error">{submitError} </p>
          )}
          <Field
            wrapperClass={"fin-col mb-3"}
            inputClassName="fin-control"
            type="text"
            name="firstName"
            component={ValidatedInput}
            placeholder="First name"
          />
          <Field
            wrapperClass={"fin-col mb-3"}
            inputClassName="fin-control"
            type="text"
            name="lastName"
            component={ValidatedInput}
            placeholder="Last name"
          />
          <Field
            wrapperClass={"fin-col mb-3"}
            inputClassName="fin-control"
            type="email"
            name="email"
            component={ValidatedInput}
            placeholder="Email"
          />
          <div className="fin-col">
            <div className={`password-wrapper ${passwordClass}`}>
              <a className="password-type-toggle">
                <i
                  className="icon-eye icon-md"
                  onClick={() => handlePasswordVisibility()}
                />
              </a>
              <Field
                inputClassName="fin-control"
                type={passwordType}
                name="password"
                component={ValidatedInput}
                placeholder="Password"
              />
              <OnChange name="password">
                {(value, previous) => {
                  if (value !== previous && !isEmpty(value)) {
                    validateSpecialChar(value);
                    validateNumber(value);
                    validateCapitalLetter(value);
                    validateLowerLetter(value);
                    validateLength(value);
                  } else {
                    setSpecialCharLink("");
                    setSpecialCharCheck("");
                    setCapitalLetterCheck("");
                    setCapitalLetterLink("");
                    setNumberLink("");
                    setNumberCheck("");
                    setLowerLetterLink("");
                    setLowerLetterCheck("");
                    setLengthLink("");
                    setLengthCheck("");
                  }
                }}
              </OnChange>
            </div>
            <p className="text-small mt-3">
              Your new password must obey the following rules
            </p>
            <ul className="text-small pl-3">
              <li className={lengthLink}>
                Be at least 8 characters long
                <i className={lengthCheck} />
              </li>
              <li className={capitalLetterLink}>
                Contain at least one capital letter
                <i className={capitalLetterCheck} />
              </li>
              <li className={lowerLetterLink}>
                Contain at least one lower letter
                <i className={lowerLetterCheck} />
              </li>
              <li className={numberLink}>
                Contain at least one number
                <i className={numberCheck} />
              </li>
              <li className={specialCharLink}>
                Contain at least one special character
                <i className={specialCharCheck} />
              </li>
            </ul>
          </div>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <label className="custom-checkbox mr-1">
              <Field
                type="checkbox"
                component="input"
                name="acceptTerms"
                id="acceptTerms"
              />
              <span>
                <a
                  href="https://www.finclude.ai/finclude-tos"
                  target="_blank"
                  rel="noreferrer"
                  className={"d-inline-block link-color"}
                >
                  Accept Terms
                </a>
                {",  "}
                <a
                  href="https://www.finclude.ai/privacy-policy"
                  target="_blank"
                  rel="noreferrer"
                  className={"d-inline-block link-color"}
                >
                  Privacy policy
                </a>
              </span>
            </label>
          </div>
          {/*when all fields are validated then remove 'disabled' attr */}
          <button
            disabled={submitting || pristine}
            id="submit"
            className="btn btn-main d-block w-100 mt-3"
          >
            Create account
          </button>
          <p className="text-small text-center mt-45">
            Already have an account?{" "}
            <Link className="d-inline-block link-color" to="/login">
              Login
            </Link>
          </p>
        </form>
      )}
    />
  );
};

SignUpForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default SignUpForm;
